/** PDF choice fields often preselect a prompt such as "Select...". That is not an answer. */
export const isChoicePlaceholder = (value: string): boolean =>
	/^select(?:\.{3}|…)?$/i.test(value.trim());
